const promotion = {
    promotion: {
        pageTitle: 'Promotion',
        pageDescription: 'We offering reasonable promotion for customers',
    
        card: {
        title: 'Join IOPS SPACE!',
        description: 'To celebrate our launch, you can use IOPS’s Ground Station Contact Scheduling service for free throughout 2025.',
        noticeTitle: 'Notice',
        noticeDetail: 'IOPS Ground station contact scheduling is limited to one Pass per day and is available only between 2 PM and 5 PM KST (5 AM to 8 AM UTC).',
        button: 'Join'
        }
    }
  };

export default promotion;